// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3913cc42","232":"7cc2814b","237":"a11ce1aa","526":"7d8abaa2","872":"d692e17e"}[chunkId] + ".chunk.js";
};